export const SUPPORT_URL = import.meta.env.VITE_IS_LOCAL
  ? 'http://localhost:4000/support'
  : `${window.ENV.HTTP_URL}/support`
